import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=121c4fa9&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=121c4fa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c4fa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('121c4fa9')) {
      api.createRecord('121c4fa9', component.options)
    } else {
      api.reload('121c4fa9', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=121c4fa9&scoped=true&", function () {
      api.rerender('121c4fa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/uiKit/checkbox.vue"
export default component.exports